const account = {
  login: login
};

const external = {
  login: externalLogin
};

export const apiService = {
  account: account,
  external: external
};

async function login(loginRequest) {
  try {
    const response = await fetch('/api/account/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(loginRequest)
    });

    const data = await response.json();

    if (response.ok) {
      return ok(data);
    } else {
      return error(data);
    };
  } catch (e) {
    return error(e.message);
  };
};

async function externalLogin() {
  try {
    const response = await fetch('/api/external/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
    });

    console.log(response);

    const data = await response.json();

    console.log(data);

    if (response.ok) {

      return ok(data);
    } else {
      return error(data);
    };
  } catch (e) {
    return error(e.message);
  };
};

function ok(data) {
  return {
    ok: true,
    message: null,
    data: data
  };
};

function error(message) {
  return {
    ok: false,
    message: message,
    data: null
  };
};

export default apiService;